/* eslint-disable-next-line  no-unused-vars */
import React, { useState, useEffect, createElement, useContext } from 'react';
import { MapContext } from '../map/MapContextProvider';
import CalculationPanel from './CalculationPanel';
import KMEANS from '../algorithm/KMEANS';
import DBSCAN from '../algorithm/DBSCAN';
import OPTICS from '../algorithm/OPTICS';
// import { OPTICS } from 'density-clustering';
import util from '../helper/util';
import supplierHelper from '../helper/supplierHelper';

export default function GroupData(props) {
    const { map, mapData, setMessages } = useContext(MapContext);
    const suplierFunctions = new supplierHelper();

    const [calcOptions, setCalcOptions] = useState({
        algorithm: 'DBSCAN',
        radius: 0.8673760610824164,
        radiusMile: 60,
        clusterSize: 2
    });
    const [drawingsRect, setDrawingsRect] = useState([]);
    const [drawingPoints, setDrawingPoints] = useState([]);
    const [drawingLines, setDrawinglines] = useState([]);
    const [newAlgorithm, setNewAlgorithm] = useState(false);

    useEffect(() => {
        suplierFunctions.setmapData(mapData);
        if (mapData.length > 0) {
            console.log(mapData);
            // onSetCalculation();
            // calculateDistance(mapData);
        }
    }, [mapData]);

    const onSetCalculation = (option) => {

        if (option)
            setCalcOptions({ ...calcOptions, option })
        else {
            option = calcOptions;
        }

        let clusters;
        //todo clear data first;
        if (option.algorithm === "KMEANS") {
            clusters = calculatekMeansClustering(mapData, option)
        } else if (option.algorithm === "DBSCAN") {
            clusters = calculateDbscanClustering(mapData, option);
        } else if (option.algorithm === "OPTICS") {
            clusters = calculateOpticsClustering(mapData, option);
        } else {
            clusters = calculateDistance(mapData, option)
        }
        // console.log(clusters);
        let [groups, outsideHubs] = generateGroups(mapData, clusters);
        if (!newAlgorithm)
            groups = calculateCentralHub(groups);
        else
            [groups, outsideHubs] = calculateCentralHub2(groups, option, outsideHubs);
        // groups = calculateOutsideHub(groups);
        console.log(groups);
        // console.log(outsideHubs);
        drawOnMap(groups);
        suplierFunctions.setGroup(groups)
        suplierFunctions.setOutsideHubs(outsideHubs)
        let summaryList = suplierFunctions.getSummary(mapData);
        let customMessages = [];
        customMessages.push("Total Suppliers: " + summaryList.supplierCount);
        customMessages.push("State Count: " + summaryList.stateCount);
        customMessages.push("Created Hubs: " + summaryList.hubCount);
        customMessages.push("State Count: " + summaryList.outsideHubCount);
        setMessages(customMessages);
    }

    const onCancelCalculation = () => {
        clearMap();
        suplierFunctions.setGroup([])
        suplierFunctions.setOutsideHubs([])
    }

    const calculatekMeansClustering = (data, options) => {
        let clusterSize = options.clusterSize;
        let dataset = [];

        if (clusterSize > data.length) {
            for (let i = 0; i < data.length; i++) {
                dataset.push([i]);
            }
            console.log(dataset)

            return dataset;
        }
        data.forEach(item => {
            let newSet = [item.latitude, item.longitude];
            dataset.push(newSet);
        });

        let customDistAlgorithm = options.distanceAlgorithm ? calculateDistanceWithTurf : undefined

        var kmeans = new KMEANS(dataset, clusterSize, customDistAlgorithm);
        // parameters: 3 - number of clusters
        var clusters = kmeans.run(dataset, clusterSize);
        console.log(clusters)
        return clusters;
    }

    const calculateDbscanClustering = (data, options) => {
        let dataset = [];
        data.forEach(item => {
            let newSet = [item.longitude, item.latitude];
            dataset.push(newSet);
        });

        let radius = options.radius;
        let neighborhood = options.clusterSize;
        var dbscan = new DBSCAN();
        let customDistAlgorithm = options.distanceAlgorithm ? calculateDistanceWithTurf : undefined
        // parameters: 5 - neighborhood radius, 2 - number of points in neighborhood to form a cluster
        var clusters = dbscan.run(dataset, radius, neighborhood, customDistAlgorithm);
        // console.log(clusters, dbscan.noise);
        return clusters;
    }

    const calculateOpticsClustering = (data, options) => {
        let dataset = [];
        data.forEach(item => {
            let newSet = [item.longitude, item.latitude];
            dataset.push(newSet);
        });

        let radius = options.radius;
        let neighborhood = options.clusterSize;
        let customDistAlgorithm = options.distanceAlgorithm ? calculateDistanceWithTurf : undefined

        var optics = new OPTICS();
        // parameters: 2 - neighborhood radius, 2 - number of points in neighborhood to form a cluster
        var clusters = optics.run(dataset, radius, neighborhood, customDistAlgorithm);
        let newCluster = [];
        clusters.forEach(element => {
            if (element.length >= neighborhood) {
                newCluster.push(element);
            }
        });
        // var plot = optics.getReachabilityPlot();
        // console.log(clusters, plot);
        return newCluster;
    }

    //generate groups with data, bounds, centers and central hubs,
    const generateGroups = (data, clusters) => {

        let groups = [];
        let notInGroupList = new Array(data.length);
        let outsideHubList = [];

        clusters.forEach((cl) => {
            let groupItems = [];
            let bound = new google.maps.LatLngBounds();
            for (let i = 0; i < cl.length; i++) {
                let clusterItemIndex = cl[i];
                notInGroupList[clusterItemIndex] = true;
                let dataItem = data[clusterItemIndex]
                bound.extend(new google.maps.LatLng(dataItem.latitude, dataItem.longitude));
                groupItems.push(dataItem)
            }
            groups.push({
                data: groupItems,
                bounds: bound,
                center: bound.getCenter(),
                centralHub: null
            });
        })

        for (let i = 0; i < notInGroupList.length; i++) {
            if (!notInGroupList[i])
                outsideHubList.push(data[i])
        }
        return [groups, outsideHubList];
    }

    const calculateCentralHub = (groups) => {

        //find the central hubs
        groups.forEach(group => {

            let center = group.center;
            let data = group.data;
            var from = turf.point([center.lng(), center.lat()]);

            for (let i = 0; i < data.length; i++) {

                let toItem = data[i];
                var to = turf.point([toItem.longitude, toItem.latitude]);

                // var distance = turf.distance(from, to);
                var distanceMile = turf.distance(from, to, { units: 'miles' });
                // var distanceKm = turf.distance(from, to, { units: 'kilometers' });
                // var distanceRad = turf.distance(from, to, { units: 'radians' });
                // var distanceDeg = turf.distance(from, to, { units: 'degrees' });


                // toItem.distance = distance;
                toItem.distanceMile = distanceMile;
                // toItem.distanceKm = distanceKm;
                // toItem.distanceRad = distanceRad;
                // toItem.distanceDeg = distanceDeg;
                // let subItem = {};
                // subItem.objId = toItem.uuid;
                // subItem.obj = toItem;
                // subItem.vendorNo = toItem.vendorNo;
                // subItem.distance = distance;
                // calculationData.push(subItem);
            }

            const utilFunc = new util();
            data.sort(utilFunc.getSortOrder('distanceMile'))
            // console.log(calculationData);
            let centralHub = data[data.length - 1];
            group.centralHub = centralHub;
        });


        groups.forEach(group => {

            let centralHub = group.centralHub;
            let data = group.data;
            var from = turf.point([centralHub.longitude, centralHub.latitude]);

            for (let i = 0; i < data.length; i++) {

                let toItem = data[i];
                var to = turf.point([toItem.longitude, toItem.latitude]);
                // var distance = turf.distance(from, to);
                var distanceMile = turf.distance(from, to, { units: 'miles' });
                var distanceKm = turf.distance(from, to, { units: 'kilometers' });
                var distanceRad = turf.distance(from, to, { units: 'radians' });
                var distanceDeg = turf.distance(from, to, { units: 'degrees' });

                // toItem.distance = distance;
                toItem.distanceMile = distanceMile;
                toItem.distanceKm = distanceKm;
                toItem.distanceRad = distanceRad;
                toItem.distanceDeg = distanceDeg;
            }
        });

        return groups;
    }

    const calculateCentralHub2 = (groups, option, outsideHubs) => {


        //find the central hubs
        groups.forEach(group => {

            let center = group.center;
            let data = group.data;
            var from = turf.point([center.lng(), center.lat()]);

            for (let i = 0; i < data.length; i++) {

                let toItem = data[i];
                var to = turf.point([toItem.longitude, toItem.latitude]);

                // var distance = turf.distance(from, to);
                var distanceMile = turf.distance(from, to, { units: 'miles' });
                // var distanceKm = turf.distance(from, to, { units: 'kilometers' });
                // var distanceRad = turf.distance(from, to, { units: 'radians' });
                // var distanceDeg = turf.distance(from, to, { units: 'degrees' });


                // toItem.distance = distance;
                toItem.distanceMile = distanceMile;
                // toItem.distanceKm = distanceKm;
                // toItem.distanceRad = distanceRad;
                // toItem.distanceDeg = distanceDeg;
                // let subItem = {};
                // subItem.objId = toItem.uuid;
                // subItem.obj = toItem;
                // subItem.vendorNo = toItem.vendorNo;
                // subItem.distance = distance;
                // calculationData.push(subItem);
            }

            const utilFunc = new util();
            data.sort(utilFunc.getSortOrder('distanceMile'))
            // console.log(calculationData);
            let centralHub = data[data.length - 1];
            group.centralHub = centralHub;
        });


        groups.forEach(group => {

            let centralHub = group.centralHub;
            let data = group.data;
            var from = turf.point([centralHub.longitude, centralHub.latitude]);
            let newData = [];
            let bound = new google.maps.LatLngBounds();

            for (let i = 0; i < data.length; i++) {

                let toItem = data[i];
                var to = turf.point([toItem.longitude, toItem.latitude]);
                // var distance = turf.distance(from, to);
                var distanceMile = turf.distance(from, to, { units: 'miles' });
                var distanceKm = turf.distance(from, to, { units: 'kilometers' });
                var distanceRad = turf.distance(from, to, { units: 'radians' });
                var distanceDeg = turf.distance(from, to, { units: 'degrees' });

                // toItem.distance = distance;
                toItem.distanceMile = distanceMile;
                toItem.distanceKm = distanceKm;
                toItem.distanceRad = distanceRad;
                toItem.distanceDeg = distanceDeg;
                if (distanceMile <= option.radiusMile) {
                    newData.push(toItem);
                    bound.extend(new google.maps.LatLng(toItem.latitude, toItem.longitude));
                }
                else {
                    outsideHubs.push(toItem);
                }
            }

            group.data = newData;
            group.bounds = bound;
            group.center = bound.getCenter();
        });

        return [groups, outsideHubs];
    }

    const drawOnMap = (groups) => {

        let rectList = [];
        let pointList = [];
        let lineList = [];

        //clear the map first
        clearMap();
        for (let i = 0; i < groups.length; i++) {
            const group = groups[i];
            const bound = group.bounds;
            const center = group.center;
            const centralHub = group.centralHub;

            // const marker = new google.maps.Marker({
            //     position: center,
            //     map: map
            // });

            const rectangle = new google.maps.Rectangle({
                strokeColor: "#FF0000",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: "#FF0000",
                fillOpacity: 0.35,
                map,
                bounds: bound.toJSON(),
                zIndex: google.maps.Marker.MAX_ZINDEX
            });


            // const circle = new google.maps.Circle({
            //     strokeColor: "#FF0000",
            //     strokeOpacity: 0.8,
            //     strokeWeight: 2,
            //     fillColor: "#FF0000",
            //     fillOpacity: 0.35,
            //     map,
            //     center: centerPt,
            //     radius: radius * 200000,
            // });


            const marker = new google.maps.Marker({
                position: new google.maps.LatLng(centralHub.latitude, centralHub.longitude),
                icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/info-i_maps.png",
                map: map,
            });

            // const centralHubPath = [
            //     { lat: centralHub.latitude, lng: centralHub.longitude },
            //     { lat: center.lat(), lng: center.lng() }
            // ];
            // const line = new google.maps.Polyline({
            //     path: centralHubPath,
            //     geodesic: true,
            //     strokeColor: "#FF0000",
            //     strokeOpacity: 1.0,
            //     strokeWeight: 2,
            //     map: map
            // });

            // setDrawinglines(rectList);

            rectList.push(rectangle);
            // lineList.push(line);
            pointList.push(marker);
        }

        setDrawingsRect(rectList);
        setDrawingPoints(pointList);
        setDrawinglines(lineList);
    }
    const clearMap = () => {
        drawingsRect.forEach((item) => {
            item.setMap(null);
        })

        drawingPoints.forEach((item) => {
            item.setMap(null);
        })

        drawingLines.forEach((item) => {
            item.setMap(null);
        })
    }

    const calculateDistanceWithTurf = (item1, item2) => {
        if (item1.length < 2) {
            console.log(item1);
        }
        if (item2.length < 2) {
            console.log(item2);
        }
        if (item1 && item2 && item1.length == 2 && item2.length == 2) {
            try {
                var from = turf.point([item1[0], item1[1]]);
                var to = turf.point([item2[0], item2[1]]);
                var options = { units: 'degrees' };
                var distance = turf.distance(from, to, options);
                return distance;
            }
            catch (err) {
                return 0;
            }

        }
        else {
            return 0;
        }
    }

    const calculateGroupMatrix = (data) => {
        let calcResult = [];
        for (let i = 0; i < data.length; i++) {
            calcResult[i] = null;
        }

        let calculationMatrix = [];
        let groupMatrix = [];
        let mile = 60;
        let groupIndex = 1;

        for (let i = 0; i < data.length; i++) {

            let item = data[i];
            let calculationItem = {};
            calculationItem.objId = item.uuid;
            calculationItem.data = [];
            var from = turf.point([item.longitude, item.latitude]);

            let gStatus = calcResult[i];

            for (let j = 0; j < data.length; j++) {

                let toItem = data[j];
                var to = turf.point([toItem.latitude, toItem.longitude]);
                var options = { units: 'miles' };
                var distance = turf.distance(from, to, options);
                if (distance < mile) {
                    //check if item already in a group
                    if (!calcResult[i]) {

                        let subItem = {};
                        subItem.objId = toItem.uuid;
                        subItem.distance = distance;
                        calculationItem.data.push(subItem);
                    }
                }

            }
            calculationMatrix.push(calculationItem);

        }
        console.log(calculationMatrix);
    }

    const findTheCentralHub = (clusters) => {
        clusters.forEach(element => {
            let turfData = [];
            for (let i = 0; i < element.length; i++) {
                const item = element[i];
                const mapItem = mapData[item];
                turfData.push([mapItem.latitude, mapItem.longitude])
            }

            let pointList = turf.points(turfData)
            let centerPoint = turf.center(pointList);

            let coords = centerPoint.geometry.coordinates;
            const loc = new google.maps.LatLng(coords[0], coords[1]);
            const marker = new google.maps.Marker({
                position: loc,
                map: map
            });

        });

    }

    const calculateDistance = (data) => {

        let calculationMatrix = [];

        for (let i = 0; i < data.length; i++) {

            let item = data[i];
            let calculationItem = {};
            calculationItem.objId = item.uuid;
            calculationItem.data = [];
            var from = turf.point([item.latitude, item.longitude]);

            for (let j = 0; j < data.length; j++) {

                let toItem = data[j];

                var to = turf.point([toItem.latitude, toItem.longitude]);
                var options = { units: 'miles' };

                var distance = turf.distance(from, to, options);

                let subItem = {};
                subItem.objId = toItem.uuid;
                subItem.distance = distance;
                calculationItem.data.push(subItem);
            }
            calculationMatrix.push(calculationItem);

        }
        console.log(calculationMatrix);
        return calculationMatrix;
    }


    return (
        <>
            {mapData.length > 0 && <CalculationPanel onSave={onSetCalculation} onCancel={onCancelCalculation} />}
        </>
    );
}

GroupData.propTypes = {

};
